import { PermissionsCategory } from "src/app/auth/permissions";

@PermissionsCategory("FiscalPermissions")
export class FiscalPermissions {
    static readonly None = 0;
    static readonly View = 1;
    static readonly EditDataInput = 2;
    static readonly Upload = 3;
}
